import Typography from 'styles/typography/Typograpy';
import { IBenefit } from 'types/Member';
import { useTranslation } from 'utils/translations';
import { formatPercentage, formatPrice } from 'utils/utils';

const MemberValueBenefit = (props: { benefit: IBenefit; width: number }) => {
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const { coPay, coInsuranceAmount, maxAmount, memberBenefitLabel } =
		props.benefit;

	return (
		<Typography
			variant="body"
			minWidth={props.width}
			maxWidth={props.width}
			pr="1rem"
		>
			{tDbLabels(memberBenefitLabel, {
				coPay: formatPrice(coPay, true),
				coInsuranceAmount: formatPercentage(coInsuranceAmount),
				maxAmount: formatPrice(maxAmount, true),
			})}
		</Typography>
	);
};

export default MemberValueBenefit;
